const getAspectRatio = (width: string | number, height: string | number): number =>
    (typeof width === 'string' ? parseFloat(width) : width) /
    (typeof height === 'string' ? parseFloat(height) : height);

export default getAspectRatio;
